<form [formGroup]="formGroup">
    <sc-flex [vertical]="true" [stretchContent]="true">
        <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>{{ 'Name' | translate: ['erp.entity.project.name', translationService.language]}}</mat-label>
            <input matInput formControlName="name" required="true">
        </mat-form-field>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div>
            <sc-flex [startAligned]="true">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Datum Start' | translate: ['erp.entity.project.start-date', translationService.language]}}</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="startDate" type="date-local">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <sc-content-spacer></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Datum Ende' | translate: ['erp.entity.project.end-date', translationService.language]}}</mat-label>
                    <input matInput [matDatepicker]="picker2" formControlName="endDate" type="date-local">
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
            </sc-flex>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div>
            <sc-flex>
                <sc-content-spacer [grow]="true"></sc-content-spacer>
                <button mat-flat-button (click)="addProject()" [disabled]="!addProjectEnabled">
                    {{ 'Übernehmen' | translate: ['erp.ui.add-project.action.confirm', translationService.language]}}
                </button>
            </sc-flex>
        </div>
    </sc-flex>
    

</form>